module.exports = __webpack_public_path__ + "img/ColoredSpace5.f61f4301.jpg";